import { render } from "./bidding-create-modal.vue?vue&type=template&id=64b612b3&ts=true"
import script from "./bidding-create-modal.vue?vue&type=script&lang=ts"
export * from "./bidding-create-modal.vue?vue&type=script&lang=ts"

import "./bidding-create-modal.vue?vue&type=style&index=0&id=64b612b3&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__